import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import { mapCustomStyles } from './mapStyles';
import pink from 'assets/images/markerPin.png';
import markerIcon from 'assets/images/marker.png';
import greenIcon from 'assets/images/green.png';
//eslint-disable-next-line
import styles from "./styles.scss";

export class MapComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      bounds: null,
    };
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props.value,
      activeMarker: marker,
      showingInfoWindow: true,
    });
    !this.props.type === 'rentals' &&
      this.props.updateFilter &&
      this.props.updateFilter(props.value);
  };

  displayMarkers = () => {
    return this.props.data.map((list, index) => {
      return this.marker(list, index);
    });
  };

  marker = (list, index) => {
    let iconUrl = pink;
    this.props.types &&
      this.props.types.map(type => {
        if (type.id === list.neighbourhoodTypeId) {
          iconUrl = type.mapIcon;
        }
      });
    return (
      <Marker
        key={index}
        id={index}
        position={{
          lat: list.latitude,
          lng: list.longitude,
        }}
        value={list}
        icon={{
          url:
            this.props.type === 'projects' || index === 'loc'
              ? markerIcon
              : iconUrl,
        }}
        onClick={this.onMarkerClick}
      />
    );
  };

  infoWindow = () => {
    return this.state.selectedPlace ? (
      <InfoWindow
        marker={this.state.activeMarker}
        visible={this.state.showingInfoWindow}
      >
        <div className={'info-window'}>
          <h4>
            {this.state.selectedPlace.name
              ? this.state.selectedPlace.name
              : null}
          </h4>
          <span>
            {this.state.selectedPlace.location
              ? this.state.selectedPlace.location
              : null}
          </span>
        </div>
      </InfoWindow>
    ) : null;
  };

  makeBounds = () => {
    const bounds = new this.props.google.maps.LatLngBounds();
    for (let i = 0; i < this.props.data.length; i++) {
      this.props.data[i].lat = this.props.data[i].latitude;
      this.props.data[i].lng = this.props.data[i].longitude;
      bounds.extend(this.props.data[i]);
    }
    this.setState({ bounds });
  };

  mapLoaded(mapProps, map) {
    this.makeBounds();
    map.setOptions({
      styles: mapCustomStyles,
      maxZoom: 12,
    });
  }

  render() {
    return (
      <Map
        google={this.props.google}
        zoom={this.props.type === 'neighbourhood' ? 13 : 4}
        style={styles}
        className={`${this.props.mapStyles} map-section`}
        initialCenter={{
          lat: this.props.pinLocation
            ? this.props.pinLocation.latitude
            : 20.593684,
          lng: this.props.pinLocation
            ? this.props.pinLocation.longitude
            : 78.96288,
        }}
        bounds={this.state.bounds}
        onReady={(mapProps, map) => this.mapLoaded(mapProps, map)}
      >
        {this.displayMarkers()}
        {this.props.type === 'neighbourhood' &&
          this.marker(this.props.pinLocation, 'loc')}
        {this.infoWindow()}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyC91pi6Pu2CdspbXs5kqbuh4r_PYfSeAjQ',
})(MapComponent);
